import { call, put, takeLatest } from "redux-saga/effects";
import mias from "../api";
import { get as _get } from "lodash";
import toast from "react-hot-toast";

import {
  GET_VERSION_LIST,
  SAVE_VERSION,
  UPDATE_VERSION,
  DELETE_VERSION,
  GET_VERSION_STATUS_UPDATE_REQUEST,
} from "../types/action-type";

import {
  saveVersionList,
  saveVersionSuccess,
  updateVersionSuccess,
  deleteVersionSuccess,
  updateVersionStatusSuccess,
} from "../actions/version";

/* ---------- GET VERSION LIST ---------- */
function* getVersionList() {
  try {
    const response = yield call(mias.apis.version.getVersionList);
    yield put(saveVersionList(_get(response, "data.data", [])));
  } catch (err) {
    console.log("get Version list saga error ::", err);
  }
}

/* ---------- SAVE VERSION ---------- */
function* saveVersionSaga(action) {
  try {
    yield call(mias.apis.version.saveVersion, action.data);
    yield put(saveVersionSuccess());

    const response = yield call(mias.apis.version.getVersionList);
    yield put(saveVersionList(_get(response, "data.data", [])));

    toast.success("Version Created!");
  } catch (error) {
    toast.error(
      _get(error, "response.data.message", _get(error, "message", ""))
    );
  }
}

/* ---------- UPDATE VERSION ---------- */
function* updateVersionSaga(action) {
  try {
    const { ...payload } = action.data;

    yield call(mias.apis.version.updateVersion, payload);
    yield put(updateVersionSuccess());

    const response = yield call(mias.apis.version.getVersionList);
    yield put(saveVersionList(_get(response, "data.data", [])));

    toast.success("Version Updated!");
  } catch (error) {
    toast.error(
      _get(error, "response.data.message", _get(error, "message", ""))
    );
  }
}

/* ---------- UPDATE VERSION STATUS ---------- */
function* updateVersionStatusSaga(action) {
  try {
    const { _id, ...payload } = action.data;

    yield call(mias.apis.version.updateVersion, _id, payload);
    yield put(updateVersionStatusSuccess());

    const response = yield call(mias.apis.version.getVersionList);
    yield put(saveVersionList(_get(response, "data.data", [])));

    toast.success("Version Status Updated!");
  } catch (error) {
    toast.error(
      _get(error, "response.data.message", _get(error, "message", ""))
    );
  }
}

/* ---------- DELETE VERSION ---------- */
function* deleteVersionSaga(action) {
    try {
  
      yield call(mias.apis.version.deleteVersion, {
        id: action.payload, // ✅ backend expects { id }
      });
  
      yield put(deleteVersionSuccess());
  
      const response = yield call(mias.apis.version.getVersionList);
      yield put(saveVersionList(_get(response, "data.data", [])));
  
      toast.success("Version Deleted!");
    } catch (error) {
      toast.error(
        _get(error, "response.data.message", _get(error, "message", ""))
      );
    }
  }

/* ---------- WATCHER ---------- */
export default function* version() {
  yield takeLatest(GET_VERSION_LIST, getVersionList);
  yield takeLatest(SAVE_VERSION, saveVersionSaga);
  yield takeLatest(UPDATE_VERSION, updateVersionSaga);
  yield takeLatest(DELETE_VERSION, deleteVersionSaga);
  yield takeLatest(
    GET_VERSION_STATUS_UPDATE_REQUEST,
    updateVersionStatusSaga
  );
}
